import appendDataLabel from '~/blocks/table/frontend/column-data-label';
import createTablePagination from '~/blocks/table/frontend/pagination';
import { addClass } from '~/js/utils/class-management';
import filterTableResult from '~/blocks/table/frontend/filter';

function appendTableHeadWrap(table: HTMLTableElement) {
  const div = document.createElement('div');
  addClass(div, 'table-head-wrap');

  table.insertAdjacentElement('beforebegin', div);
}

function makeDataTables() {
  const tables = document.querySelectorAll('table');
  if (!tables.length) return;

  tables.forEach((table) => {
    const header = document.querySelectorAll('th');
    const tbody = table.querySelector('tbody') as HTMLTableSectionElement;
    const rows = tbody.querySelectorAll('tr');
    const arrayRows = Array.from(rows);

    const itemsPerPage = parseInt(
      table.getAttribute('data-pagination-count') || '3'
    );

    appendTableHeadWrap(table);

    appendDataLabel(header, arrayRows);

    if (arrayRows.length > itemsPerPage) {
      createTablePagination(arrayRows, table, itemsPerPage);
    }

    filterTableResult(table, itemsPerPage);
  });
}

export default makeDataTables;
